"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REFRESH_PROFILE = exports.LOGOUT = void 0;
var LOGOUT = "LOGOUT";
exports.LOGOUT = LOGOUT;
var REFRESH_PROFILE = "REFRESH_PROFILE";
exports.REFRESH_PROFILE = REFRESH_PROFILE;